export default __webpack_public_path__ + "static/media/video1.b1d1e3ae.mp4";